module.exports = [
    {
        title: '国务院执行法规',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 1,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '地方性法规',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 2,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '部门规章',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 3,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '地方性政府规章',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 4,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '规范性文件',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 5,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '制度文件',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 5,
            msgType: 6,
        },
        data: [],
        target: 'HtmlPage',
    },
]
